import { useCurrentSubscriptionApi } from '@aibees/shared/features/price-and-plan/api/use-current-subscription-api';
import { useRateLimitReachedStore } from '@aibees/shared/store';
import { useMemo } from 'react';

export function useSearchLimitRestriction() {
  const { data } = useCurrentSubscriptionApi();
  const { isError: limitReached, setIsError: setLimitReached } =
    useRateLimitReachedStore();

  const isFreeUser = useMemo(() => {
    return data?.current?.plan?.metadata.is_free === 'true';
  }, [data]);

  return { limitReached, isFreeUser, setLimitReached };
}
